// plugins/iugu.js

// Em modo de teste a Iugu só aceita cartões de teste e devolve "Number is invalid" para cartões reais.
// Valor vazio mantém o padrão (teste fora de produção); "true"/"false" força o modo.
export const resolveIuguTestMode = (explicitValue, appEnv) => {
    const value = String(explicitValue ?? '').trim().toLowerCase();
    if (['true', '1', 'yes', 'on'].includes(value)) return true;
    if (['false', '0', 'no', 'off'].includes(value)) return false;
    return appEnv !== 'production';
};

const loadIuguScript = () => {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://js.iugu.com/v2";
        script.type = "text/javascript";
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
};

const initIugu = async (options) => {
    await loadIuguScript();
    Iugu.setAccountID(options.accountID);
    if (options.testMode) {
        Iugu.setTestMode(true);
    }
};

const createCreditCardObj = (cardData) => {
    const number = cardData.number.replace(/\D/g, '');
    const expiration_month = cardData.expiration.split('/')[0];
    const expiration_year = cardData.expiration.split('/')[1];
    const cvv = cardData.verification_value;
    const first_name = cardData.first_name;
    const last_name = cardData.last_name;

    return Iugu.CreditCard(number, expiration_month, expiration_year, first_name, last_name, cvv);
    
}

const IuguClient = {
    install: (app, options) => {
        app.config.globalProperties.$iugu = {
            init: () => initIugu(options),
            createPaymentToken(cardData) {
                return new Promise((resolve, reject) => {
                    const card = createCreditCardObj(cardData);
                    Iugu.createPaymentToken(card, (response) => {
                        if (response.errors) {
                            reject(response.errors);
                        } else {
                            resolve(response.id);
                        }
                    });
                });
            },
            isBlockedByAdBlock() {
                return Iugu.utils.isBlockedByAdBlock();
            },
            isTestMode() {
                return Boolean(options.testMode);
            },
            validateCard(cardData) {
                const errors = {};
                
                const isNameValid = cardData.first_name && cardData.first_name.trim() !== '' && cardData.last_name && cardData.last_name.trim() !== '';
                if (!isNameValid) {
                    errors.full_name = 'Invalid name';
                }

                const isNumberValid = Iugu.utils.validateCreditCardNumber(cardData.number);
                if (!isNumberValid) {
                    errors.number = 'Invalid credit card number';
                }

                const isExpirationValid = Iugu.utils.validateExpirationString(cardData.expiration);
                if (!isExpirationValid) {
                    errors.expiration = 'Invalid expiration date';
                }

                const brand = Iugu.utils.getBrandByCreditCardNumber(cardData.number) || 'visa';
                const isCVVValid = Iugu.utils.validateCVV(cardData.verification_value, brand);
                if (!isCVVValid) {
                    errors.verification_value = 'Invalid CVV';
                }

                return {
                    valid: isNumberValid && isExpirationValid && isCVVValid && isNameValid,
                    errors: Object.keys(errors).length ? errors : null
                };
            },
            setupFormatter() {
                Iugu.setup();
            }
        };
    }
};

export default IuguClient;